<template>
    <div class="index-view">
        
    </div>
</template>

<script>
export default {
    methods: {
        redirectMain(){
            window.location.href = 'https://www.pbseducation.com/index.php'
        }
    },
    mounted() {
        this.redirectMain()
    }
}
</script>